/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import store from '../../../../../redux/store';
import { Button, PlusIconSVG } from 'cx-ui-components';

const AddFilterContainer = styled.div`
  display: flex;
  width: 70%;
  font-size: 14px;
  margin-left: 20px;
  margin-top: 10px;
`;
const Label = styled.label`
  display: inline-block;
  flex-shrink: 0;
  font-size: 14px;
  width: 190px;
  margin-top: 5px;
  padding-right: 10px;
`;
const ActionButton = styled(Button)`
  margin-left: 10px;
  height: 32px;
  padding: 3px 10px;
  background-color: 'inherit';
`;

export const AddSearchQuery = ({ index }) => (
  <AddFilterContainer>
    <Label>{`Add level ${index} search Query`}</Label>
    <ActionButton
      type="button"
      onClick={() => store.dispatch({ type: 'ADD_SEARCH_QUERY_LEVEL', index: index })}
      id="add-search-query"
      title="Add Query"
      data-automation="searchQueryAddItem">
      <PlusIconSVG size={12} plusIconType="primary" />
    </ActionButton>
  </AddFilterContainer>
);

AddSearchQuery.propTypes = {
  index: PropTypes.number,
};
